import styled, { keyframes } from "styled-components";

const pulse = keyframes`
  0% {
    opacity: 1;
  }
  50% {
    opacity: 0.5;
  }
  100% {
    opacity: 1;
  }
`;

export const SkeletonCard = styled.div`
  height: 300px;
  background-color: #f0f0f0;
  border-radius: 8px;
  animation: ${pulse} 1.5s ease-in-out infinite;
`;

export const ErrorMessage = styled.div`
  padding: 20px;
  text-align: center;
  color: #666;
  grid-column: 1 / -1;
`;
